import React, { Component } from "react";
import { Paper } from "material-ui";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from "recharts";
import Loading from "../../Loading";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";

export default class PeopleIndex extends Component {
  componentWillMount() {
    this.props.authFetchWorkorders("teamwork/people", this.props.token.jwt);
  }

  getStyles() {
    return {
      container: {
        textAlign: "center",
        display: "flex",
      },
      center: {
        textAlign: "center",
      },
      paperDiv: {
        width: "47%",
        margin: 20,
        display: "inline-block",
        alignSelf: "flex-start",
      },
    };
  }

  render() {
    let { center, paperDiv, container } = this.getStyles();
    let filter = { type: "TextFilter", delay: 500 };

    if (this.props.isLoading) {
      return (
        <div className="container">
          <center>
            <Loading color={this.props.appbar.color} />
          </center>
        </div>
      );
    } else {
      return (
        <Paper
          className="container"
          zDepth={2}
          style={{ marginTop: "2em", paddingTop: "1em" }}
        >
          <center>
            <BarChart
              width={1000}
              height={300}
              data={this.props.workOrders}
              margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
              onClick={this.handleClick}
            >
              <XAxis dataKey="shortUsername" />
              <YAxis />
              <CartesianGrid strokeDasharray="3 3" />
              <Tooltip />
              <Legend />
              <Bar dataKey="taskCount" fill={this.props.appbar.color} />
            </BarChart>
          </center>
          <br />
          <BootstrapTable data={this.props.workOrders} pagination>
            <TableHeaderColumn
              dataField="shortUsername"
              dataSort
              filter={filter}
              isKey
            >
              Username
            </TableHeaderColumn>
            <TableHeaderColumn dataField="firstName" dataSort filter={filter}>
              First Name
            </TableHeaderColumn>
            <TableHeaderColumn dataField="lastName" dataSort filter={filter}>
              Last Name
            </TableHeaderColumn>
            <TableHeaderColumn dataField="taskCount" dataSort filter={filter}>
              Task Count
            </TableHeaderColumn>
          </BootstrapTable>
        </Paper>
      );
    }
  }

  handleClick = (data) => {
    console.log("clicked", data);
  };
}



// WEBPACK FOOTER //
// ./app/components/teamwork/people/PeopleIndex.js